import { Box, ClickAwayListener, Divider, styled } from "@mui/material";
import MenuItems from "./MenuItems";

const TopBarMenuRoot = styled(Box)(({ theme }) => {
  return {
    display: "grid",
    gap: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.main,
    position: "absolute",
    top: "100%",
    insetInline: 0,
    padding: theme.spacing(1),
    paddingTop: 0,
    boxShadow: "0 2px 10px #0006",
    clipPath: "inset(0px -10px -10px -10px)", // prevent shadow from spilling onto header
    "@media (min-width: 600px)": {
      maxWidth: "400px",
      borderBottomLeftRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
    },
  };
});

type TopBarMenuProps = { onClose: () => void };

const TopBarMenu: React.FC<TopBarMenuProps> = (props) => {
  const { onClose } = props;

  return (
    <ClickAwayListener onClickAway={onClose}>
      <TopBarMenuRoot>
        <Divider color="black" className="TopBar-divider" />

        <MenuItems onClickItem={onClose} />
      </TopBarMenuRoot>
    </ClickAwayListener>
  );
};

export default TopBarMenu;
